<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>用户认证</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>用户认证</h4>
        <!-- <p @click="addPic">+新增图库</p> -->
      </div>

      <div class="tabsbody">
        <el-tabs type="border-card">
          <el-tab-pane label="待审核">
            <div class="tablebg"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <userauthtable :tableData="picTableList"
                               :ischeckStatus="true"
                               @changeClick="formSubmit"
                               @rufuseClick="closeClick"
                               @disableClick="removeClick"></userauthtable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="currentPage"
                               :page-size="pageSize"
                               layout="prev, pager, next"
                               :total="total">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已通过">
            <div class="tablebg"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <userauthtable :tableData="adoptTableList"
                               :ischeckStatus="false"
                               @changeClick="formSubmit"
                               @rufuseClick="closeClick"
                               @disableClick="removeClick"></userauthtable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChangeAdopt"
                               @current-change="handleCurrentChangeAdopt"
                               :current-page.sync="currentPageAdopt"
                               :page-size="pageSizeAdopt"
                               layout="prev, pager, next"
                               :total="totalAdopt">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已拒绝">
            <div class="tablebg"
                 v-loading="isRefresh">
              <div style="width:100%;margin:0 auto;">
                <userauthtable :tableData="refTableList"
                               :ischeckStatus="false"
                               @changeClick="formSubmit"
                               @rufuseClick="closeClick"
                               @disableClick="removeClick"></userauthtable>
              </div>

              <div class="pagination">
                <el-pagination @size-change="handleSizeChangeRef"
                               @current-change="handleCurrentChangeRef"
                               :current-page.sync="currentPageRef"
                               :page-size="pageSizeRef"
                               layout="prev, pager, next"
                               :total="totalRef">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

    <el-dialog width="28%"
               :before-close="handleClose"
               :visible.sync="mydialogVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>审核操作</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               :rules="rules">
        <el-form-item label="认证名:"
                      label-width="80px"
                      prop="name">
          <div>{{dataInfo.realName}}</div>
        </el-form-item>
        <el-form-item label="审核备注:"
                      label-width="80px"
                      prop="mobile">
          <el-input type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12}"
                    v-model="myform.desc"
                    placeholder="备注选填，不超过200字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                  :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="dialogSubmit('myform')">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userauthtable } from "@/components/index";
import { mapActions } from "vuex";
import { listUserAuthInfo, updateUserAuthInfo, getUser, updateUser, checkUserAuthInfo } from "@/api/user";
import { getDate, formatConversion } from "@/plugins/getdate";
export default {
  components: {
    userauthtable
  },

  data () {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,

      totalAdopt: 0,
      currentPageAdopt: 1,
      pageSizeAdopt: 10,

      totalRef: 0,
      currentPageRef: 1,
      pageSizeRef: 10,

      mydialogVisible: false,
      dataInfo: '',
      myform: {
        name: "",
        desc: ""
      },
      rules: {
        desc: [
          { min: 0, max: 200, message: "长度在 0 到 200 个字符", trigger: "blur" }
        ]
      },
      //待审核列表
      picTableList: [],

      //已通过列表
      adoptTableList: [],

      //已通过列表
      refTableList: [],

      timeInt: '',
      isRefresh: false
    };
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),


    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      let data = { page: (this.currentPage - 1), pageSize: this.pageSize, checkStatus: 0 }
      // console.log(data)
      this.listUserAuthInfoAsync(data)
    },

    //分页事件
    handleSizeChangeAdopt (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChangeAdopt (val) {
      this.currentPageAdopt = val
      let data = { page: (this.currentPageAdopt - 1), pageSize: this.pageSizeAdopt, checkStatus: 1 }
      // console.log(data)
      this.adoptlistUserAuthInfoAsync(data)
    },

    //分页事件
    handleSizeChangeRef (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChangeRef (val) {
      this.currentPageRef = val
      let data = { page: (this.currentPageRef - 1), pageSize: this.pageSizeRef, checkStatus: 2 }
      // console.log(data)
      this.reflistUserAuthInfoAsync(data)
    },

    //刷新表格
    refresh () {

      this.isRefresh = true
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.handleCurrentChangeAdopt(this.currentPageAdopt)
      }, 100);
      setTimeout(() => {
        this.handleCurrentChangeRef(this.currentPageRef)
      }, 200);
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },



    //子组件picmanagetable传递过来的方法：用于新增图片库
    dialogSubmit (data) {
      let mydata = {
        checkStatus: 2,
        id: this.dataInfo.id,
        uid: this.dataInfo.uid,
        checkNote: this.myform.desc
      }
      // mydata.checkNote = this.myform.desc
      this.checkUserAuthInfoAsync(mydata)
      this.mydialogVisible = false
      // console.log(willToPushData)

    },

    //子组件dialog的方法：用于修改是否隐藏dialog的值   不予picmanagetable组件中的dialog组件重复
    changedialogFormVisible (data) {
      this.tableDialogFormVisible = data;
    },
    handleClose () {
      this.mydialogVisible = false
    },

    //通过事件
    formSubmit (data) {
      this.$confirm("确定通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          // console.log(data)
          let mydata = {
            checkStatus: 1,
            id: data.row.id,
            uid: data.row.uid,
          }
          // console.log(mydata)
          this.checkUserAuthInfoAsync(mydata)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },
    //删除图片库信息事件
    async removeClick (data) {
      this.$confirm("确定禁用该账号吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          let mydata = {
            checkStatus: 2,
            id: data.row.id,
            uid: data.row.uid,
          }
          this.getUserAsync(data.row.uid)
          this.checkUserAuthInfoAsync(mydata)
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },
    //关闭或开始图片库
    closeClick (data) {
      this.dataInfo = data.row
      this.mydialogVisible = true
      // this.$confirm("确认拒绝改账号吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(() => {

      //   })
      //   .catch(() => {
      //     // this.$message({
      //     //   type: "info",
      //     //   message: "已取消"
      //     // });
      //   });

    },

    //查询用户信息
    async getUserAsync (val) {
      let { status, data, message, errors } = await getUser(val);
      if (status) {
        data.status = 0
        this.updateUserAsync(data)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    async checkUserAuthInfoAsync (val) {
      let { status, data, message, errors } = await checkUserAuthInfo(val);
      if (status) {
        this.$message.success(message)
        this.handleCurrentChange(this.currentPage);
        this.handleCurrentChangeAdopt(this.currentPageAdopt)
        this.handleCurrentChangeRef(this.currentPageRef)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改用户信息
    async updateUserAsync (val) {
      let { status, data, message, errors } = await updateUser(val);
      if (status) {
        // this.$message.success('修改成功!')
        // this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //修改用户认证信息
    async updateUserAuthInfoAsync (val) {
      let { status, data, message, errors } = await updateUserAuthInfo(val);
      if (status) {
        this.$message.success('修改成功!')
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //获取待审核列表
    async listUserAuthInfoAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listUserAuthInfo(val);
      if (status) {
        this.picTableList = data;
        this.total = pagination.total
        console.log(this.total);
        for (let i = 0; i < this.picTableList.length; i++) {
          if(this.picTableList[i].createAt){
            this.picTableList[i].createAtMY = formatConversion(this.picTableList[i].createAt.toString()).substring(0, 2) + formatConversion(this.picTableList[i].createAt.toString()).substring(4, 10)
          }
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

    //获取已通过列表
    async adoptlistUserAuthInfoAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listUserAuthInfo(val);
      if (status) {
        this.adoptTableList = data;
        this.totalAdopt = pagination.total

        console.log(this.totalAdopt);
        for (let i = 0; i < this.adoptTableList.length; i++) {
          if (this.adoptTableList[i].createAt) {
            this.adoptTableList[i].createAtMY = formatConversion(this.adoptTableList[i].createAt.toString()).substring(0, 2) + formatConversion(this.adoptTableList[i].createAt.toString()).substring(4, 10)
          }
          
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    //获取已通过列表
    async reflistUserAuthInfoAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listUserAuthInfo(val);
      if (status) {
        this.refTableList = data;
        this.totalRef = pagination.total

        console.log(this.totalRef);
        for (let i = 0; i < this.refTableList.length; i++) {
          if (this.refTableList[i].createAt) {
            this.refTableList[i].createAtMY = formatConversion(this.refTableList[i].createAt.toString()).substring(0, 2) + formatConversion(this.refTableList[i].createAt.toString()).substring(4, 10) 
          }
        }
        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },

  },
  created () {
    
    this.handleCurrentChange(this.currentPage);
    setTimeout(() => {
      this.handleCurrentChangeAdopt(this.currentPageAdopt)
    }, 100);
    setTimeout(() => {
      this.handleCurrentChangeRef(this.currentPageRef)
    }, 200);
    
    this.timeInt = setInterval(() => {
      // this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {  // 组件销毁前调用
    clearTimeout(this.timeInt)
  },
  mounted () { }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./userauth.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}
</style>
